import { useMemo } from 'react';
import { useAuth } from '../contexts/useAuth';
import { resolveAppHomePath, type AppHomePath } from '../lib/appHomePath';

export function useAppHomePath(): AppHomePath {
  const { roleContext } = useAuth();
  return useMemo(() => resolveAppHomePath(roleContext), [roleContext]);
}
